export enum EnumUTACopyTAInvestorFormField {
  accountType = 'accountType',
  copyType = 'copyType',
  lot = 'lot',
  leverage = 'leverage',
}
